<template>
  <div>
    <label
      class="input__label label"
      :for="id"
      v-if="translate(label)"
    >
      {{ translate(label) }}

      <span class="sr-only"> {{ index + 1 }}</span>
    </label>

    <div class="d-flex justify-content-between align-items-center margin__t--6">
      <div class="flex-grow-1 margin__r--12">
        <input-email
          :id="id"
          :aria-label="`${t('literal.email')} ${index + 1}`"
          :v="validator"
          v-model="model"
        />
      </div>

      <button
        class="link__color--black-danger"
        type="button"
        :title="t('literal.delete_email')"
        :aria-label="`${t('literal.delete_email')} ${index + 1}`"
        @click.prevent="emit('delete')"
      >
        <fa-icon :icon="['fal', 'trash']" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { guid } from '@/utils/utils'

import InputEmail from '&/atoms/InputEmail'

const emit = defineEmits(['update:modelValue', 'delete'])

const model = defineModel({ type: String, default: '' })

defineProps({
  label: Object,
  index: Number
})

const id = `field${guid(4)}`

const { t, translate } = useI18n()
const { validator } = useProcedureBlockValidator({ validations: ['email'], state: model })
</script>

<style lang="scss" scoped>
.label {
  font-size: rem(14px);
}
</style>